import React from 'react';
import { t } from 'ttag';
import {
  AuthForm,
  AuthField,
  AuthLink,
  AuthMessage
} from '../../../UnifiedComponents';
import { createLoginValidationSchema } from '../../validationSchemas';

const ExistingUserForm = ({
  theme,
  inviteInfo,
  initialValues,
  onSubmit,
  isSubmitting,
  loginState,
  onForgotPassword
}) => {
  return (
    <AuthForm
      theme={theme}
      initialValues={initialValues}
      validationSchema={createLoginValidationSchema(inviteInfo)}
      onSubmit={onSubmit}
      submitButtonText={isSubmitting ? t`Logging in...` : t`Login`}
      isSubmitting={isSubmitting}
    >
      {/* Username Field */}
      <AuthField
        theme={theme}
        label={t`Username`}
        name="username"
        required
        disabled
      />

      {/* Password Field */}
      <AuthField
        theme={theme}
        label={t`Password`}
        name="password"
        type="password"
        required
      />

      {/* Subscription Code Field - only show if required */}
      {inviteInfo?.setSubscription && (
        <AuthField
          theme={theme}
          label={t`Subscription Code`}
          name="subscriptionCode"
          required
        />
      )}

      {/* Login Error Message */}
      {loginState.error && (
        <AuthMessage
          theme={theme}
          type="error"
          message={loginState.error}
        />
      )}

      {/* Forgot Password Link */}
      <div style={{ textAlign: 'center', marginTop: '16px' }}>
        <AuthLink
          theme={theme}
          onClick={onForgotPassword}
          ariaLabel={t`Navigate to forgot password page`}
        >
          {t`Forgot Password?`}
        </AuthLink>
      </div>
    </AuthForm>
  );
};

export { ExistingUserForm };
